import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import defaultObjEquals from '_legacy/components/grid/columnDefaults/defaultObjEquals';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import BlanksFilterRenderer from '_legacy/components/grid/renderers/BlanksFilterRenderer';

export const vesselEngineTypeHeading = {
    colId: 'engineType',
    headerName: 'Engine',
    field: 'vessel.engineType',
    editable: false,
    comparator: naturalSortComparator,
    equals: defaultObjEquals,
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    hide: true,
    width: 120,
    filterParams: {
        ...defaultSetFilterParams,
        cellRenderer: BlanksFilterRenderer,
        comparator: naturalSortComparator,
    },
    suppressPaste: false,
};
